<div class="brand">
	<i class="fa-solid fa-chart-line"></i>
	<span>EforAll Data Dashboards</span>
</div>

<div class="right-side">

	@if(!isSmall()) {
	<droplist [items]='droplistItems()' [selectedItem]='selectedDroplistItem()'
		(selectionChange)='onDroplistChange($event)' [filterable]='false' [navigation]='true' sortBy='customSort'
		[groupSortValues]="{ 'My': 1 }" style='display:inline-block'>
	</droplist>
	}

	<button class="btn toolbar-btn" (click)="toggleMenu()">
		<i class="fa-regular fa-plus" (click)="addDashboard.start()"></i>
	</button>

	<button #menuBtn class="btn toolbar-btn" (click)="toggleMenu()">
		<i class="fa-regular fa-bars"></i>
	</button>

	@if (isMenuOpen()) {
	<ul #menu class="dropdown-menu">
		<li (click)="changeList('Available')">Available Dashboards</li>
		<li (click)="changeList('Personal')">Personal Dashboards</li>
		<li (click)="changeList('Recent')">Recent Dashboards</li>
		<li (click)="changeList('Starred')">Starred Dashboards</li>
		<li (click)="changeList('Trashed')">Trashed Dashboards</li>
		<li (click)="changeList('Orphaned')">Orphaned Dashboards</li>
		<li class="sign-out" (click)="signOut()">Sign out</li>
	</ul>
	}
</div>